import React from 'react';

import Card from '../../Card/CardContent';
import { CardSkeleton } from '../../../Skeleton';
import SmartCardView from './SmartCardView';
import useSmartCardData from './useSmartCardData';

const SmartCardContentContainer = ({
  chartDefinition,
}: {
  chartDefinition: V5ChartDefinition;
}) => {
  const {
    h,
    isLoadingInitial,
    shouldFallbackToCard,
    smartCardProps,
    isLoading,
  } = useSmartCardData({ chartDefinition });

  if (isLoadingInitial) {
    return <CardSkeleton />;
  }
  if (shouldFallbackToCard) {
    return <Card chartDefinition={chartDefinition} />;
  }
  if (!smartCardProps) {
    return <CardSkeleton />;
  }

  return <SmartCardView {...smartCardProps} isLoading={isLoading} h={h} />;
};

export default SmartCardContentContainer;
